import { CSSProperties } from "react";

/**
 * (thuang): Copied from the style of the graph-canvas element
 * to ensure both openseadragon and the canvas are resizable
 */
export const COMMON_CANVAS_STYLE: CSSProperties = {
  position: "absolute",
  top: 0,
  left: 0,
  padding: 0,
  margin: 0,
};
